import Swiper from 'swiper/bundle';

//トップページ
export function fpFunc() {
  // const swiper = new Swiper('.swiper-container', {
  //   autoplay: {
  //     delay: 5000
  //   },
  //   loop: true,
  //   slidesPerView: 2,
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev',
  //   },
  //   breakpoints: {
  //     768: {
  //       slidesPerView: 3,
  //     }
  //   }
  // });

  const ColumnSwiper = new Swiper('.single-column-slide', {
    // autoplay: {
    //   delay: 5000
    // },
    loop: true,
    slidesPerView: 2,
    centeredSlides: false,

    navigation: {
      nextEl: '#swiper-button-next-column',
      prevEl: '#swiper-button-prev-column',
    },
    spaceBetween: 15,
    breakpoints: {
      768: {
        slidesPerView: 3,
      }
    }
  });

  const CourseSwiper = new Swiper('.single-course-slide', {
    // autoplay: {
    //   delay: 5000
    // },
    loop: true,
    slidesPerView: 2,
    centeredSlides: false,

    navigation: {
      nextEl: '#swiper-button-next-course',
      prevEl: '#swiper-button-prev-course',
    },
    spaceBetween: 15,
    breakpoints: {
      768: {
        slidesPerView: 3,
      }
    }
  });

  const CustomerSwiper = new Swiper('.customer-slide', {
    // autoplay: {
    //   delay: 5000
    // },
    loop: true,
    slidesPerView: 2,
    centeredSlides: false,

    navigation: {
      nextEl: '#swiper-button-next-customer',
      prevEl: '#swiper-button-prev-customer',
    },
    // spaceBetween: 15,
    breakpoints: {
      768: {
        slidesPerView: 3,
      }
    }
  });
}
